module.exports = __webpack_public_path__ + "img/shipo-menu-schedule-of-shipment.95e8b3b1.svg";